import React from 'react';
import styled from 'styled-components';
import { ListItemText } from '@mui/material';
import Checkbox from '../../Checkbox/Checkbox';
import MenuItemStyled from '../../DropDown/shared/MenuItemStyled';
import { componentToken } from '../../../style/utils';

const MenuItemWrapper = styled.div`
  padding-left: ${componentToken('filterChip.menuItemWrapper.paddingLeft')};
  padding-right: ${componentToken('filterChip.menuItemWrapper.paddingRight')};
`;

const SelectAllMenuItem = styled(MenuItemStyled)`
  margin-top: ${componentToken('filterChip.selectAllMenuItem.marginTop')};
  margin-bottom: ${componentToken('filterChip.selectAllMenuItem.marginBottom')};
  display: flex;
  gap: ${componentToken('filterChip.selectAllMenuItem.gap')};
`;

const SelectAllText = styled(ListItemText)`
  padding-right: ${componentToken('filterChip.selectAllText.paddingRight')};
`;

interface SelectAllItemProps {
  checked: boolean;
  indeterminate: boolean;
  multiple?: boolean;
  disabled: boolean;
  onClick: () => void;
}

const SelectAllItem = ({
  checked,
  indeterminate,
  multiple,
  disabled,
  onClick,
}: SelectAllItemProps) => {
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <MenuItemWrapper>
      <SelectAllMenuItem
        value="all"
        $multiple={multiple}
        onClick={handleClick}
        selected={checked}
        disabled={disabled}
      >
        <Checkbox checked={checked} indeterminate={indeterminate} />
        <SelectAllText primary="Select all" />
      </SelectAllMenuItem>
    </MenuItemWrapper>
  );
};

export default SelectAllItem;
